import { useState } from 'react';
import { Card, Form, Input, Select, Button, Tabs,message, Space, Image, Spin } from 'antd';
import { RobotOutlined, SendOutlined, CopyOutlined, ReloadOutlined } from '@ant-design/icons';
import { aiAPI } from '../../api/ai';

const { TextArea } = Input;

const AICreatorPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [activeTab, setActiveTab] = useState('copywriting');

  const handleGenerate = async (values) => {
    setLoading(true);
    try {
      const res = await aiAPI.generate(values);
      setResult(res.data);
      message.success('生成成功');
    } catch {
      message.error('生成失败');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    message.success('已复制');
  };

  const platforms = [
    { value: 'douyin', label: '抖音' },
    { value: 'xiaohongshu', label: '小红书' },
    { value: 'tiktok', label: 'TikTok' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'youtube', label: 'YouTube' },
    { value: 'amazon', label: '亚马逊' },
    { value: 'shopify', label: 'Shopify' },
    { value: 'independent', label: '独立站' },
  ];

  const languages = [
    { value: 'zh', label: '中文' },
    { value: 'en', label: '英语' },
    { value: 'es', label: '西班牙语' },
    { value: 'ar', label: '阿拉伯语' },
    { value: 'ja', label: '日语' },
    { value: 'ko', label: '韩语' },
    { value: 'fr', label: '法语' },
    { value: 'de', label: '德语' },
    { value: 'pt', label: '葡萄牙语' },
    { value: 'ru', label: '俄语' },
    { value: 'th', label: '泰语' },
    { value: 'vi', label: '越南语' },
    { value: 'id', label: '印尼语' },
    { value: 'ms', label: '马来语' },
  ];

  const styles = [
    { value: 'casual', label: '活泼有趣' },
    { value: 'professional', label: '专业正式' },
    { value: 'emotional', label: '温情走心' },
    { value: 'promotional', label: '种草推荐' },
    { value: 'luxury', label: '奢华高端' },
    { value: 'minimal', label: '极简主义' },
  ];

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <Card title={<span><RobotOutlined /> AI创作中心</span>} extra={<Space>
        <Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button>
        <Button type="primary" icon={<SendOutlined />} onClick={() => form.submit()}>生成</Button>
      </Space>}>
        <Tabs activeKey={activeTab} onChange={setActiveTab} items={[
          { key: 'copywriting', label: '📝 智能文案', children: (
            <Form form={form} onFinish={handleGenerate} layout="vertical" initialValues={{ count: 3, language: 'en', platform: 'amazon', style: 'professional' }}>
              <Form.Item name="product" label="产品信息" rules={[{ required: true, message: '请输入产品信息' }]}>
                <TextArea placeholder="输入产品名称、特点、卖点等" rows={3} />
              </Form.Item>
              <Form.Item name="audience" label="目标受众">
                <Input placeholder="例如：25-35岁女性，注重品质" />
              </Form.Item>
              <Space size="large">
                <Form.Item name="platform" label="目标平台"><Select options={platforms} style={{ width: 160 }} /></Form.Item>
                <Form.Item name="language" label="输出语言"><Select options={languages} style={{ width: 160 }} /></Form.Item>
                <Form.Item name="style" label="文案风格"><Select options={styles} style={{ width: 160 }} /></Form.Item>
                <Form.Item name="count" label="生成数量"><Input type="number" min={1} max={10} style={{ width: 100 }} /></Form.Item>
              </Space>
            </Form>
          )},
          { key: 'image', label: '🖼️ AI生图', children: (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <Image src="https://via.placeholder.com/400x300?text=AI+Image+Generation" />
              <p>上传产品图，自动生成场景图、宣传海报</p>
              <Spin spinning={loading} tip="生成中..." />
            </div>
          )},
          { key: 'video', label: '🎬 数字人视频', children: (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <p>选择数字人形象，自动生成口播视频</p>
              <Space wrap>
                {['👩‍💼 商务女', '👨‍💼 商务男', '👩‍🎤 活力女', '👨‍🎓 知性男'].map((avatar) => (
                  <Card key={avatar} size="small" hoverable style={{ width: 120 }}>
                    <div style={{ fontSize: 40 }}>{avatar.split(' ')[0]}</div>
                    <div>{avatar.split(' ')[1]}</div>
                  </Card>
                ))}
              </Space>
            </div>
          )},
        ]} />
      </Card>

      {result && (
        <Card title="生成结果" extra={<Button icon={<CopyOutlined />} onClick={() => copyToClipboard(result)}>复制全部</Button>}>
          <pre style={{ whiteSpace: 'pre-wrap', background: '#f5f5f5', padding: 16, borderRadius: 8 }}>
            {result}
          </pre>
        </Card>
      )}
    </div>
  );
};

export default AICreatorPage;
